import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CanvasService } from '../../canvas.service';

@Component({
  selector: 'app-canvas-document-details',
  templateUrl: './canvas-document-details.component.html',
  styleUrl: './canvas-document-details.component.scss',
})
export class CanvasDocumentDetailsComponent {
  docuemntContent: any = null;
  isLoadingDocument: boolean = false;

  subs: Subscription[] = [];

  get sourceDocument() {
    return this.data.sourceDocument ?? null;
  }

  constructor(
    public hubService: CanvasService,
    private readonly sanitizer: DomSanitizer,
    private readonly dialogRef: MatDialogRef<CanvasDocumentDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.getDocumentDetails();
  }

  closeDocumentDetails() {
    this.dialogRef.close();
  }

  getDocumentDetails() {
    this.isLoadingDocument = true;
    this.docuemntContent = null;
    if (this.sourceDocument) {
      this.subs.push(
        this.hubService.getDocumentDetails(this.sourceDocument).subscribe({
          next: (response: any) => {
            this.isLoadingDocument = false;
            if (response?.content) {
              this.docuemntContent = this.sanitizer.bypassSecurityTrustHtml(
                this.hubService.getConvertedMessage(response.content ?? '')
              );
            }
          },
          error: (error) => {
            this.isLoadingDocument = false;
          },
        })
      );

      return;
    }
    this.isLoadingDocument = false;
  }

  ngOnDestroy(): void {
    this.subs?.forEach((sub) => sub?.unsubscribe());
  }
}
